import React from 'react'
import { Redirect } from 'react-router-dom'
import { useSsoSuccessfulSignIn } from '../../operations'
import { routes } from 'constants/routes'
import { DynamicLoadingPage } from 'containers/DynamicLoadingPage'
import { setSketchUrlScheme } from 'utils'

const SsoSuccessfulSignInView = () => {
  const { state } = useSsoSuccessfulSignIn()

  switch (state.type) {
    case 'loading':
      return <DynamicLoadingPage />
    case 'success-cloud':
      return <Redirect to={state.from ?? routes.ENTRY.create({})} />
    case 'success-sketch-app':
      window.location.href = setSketchUrlScheme(
        `sketch.cloud/signin/sso/success?token=${state.exchangeToken}`
      )
      return null
    case 'error':
      return <Redirect to={routes.SSO_SIGN_IN.create({})} />
  }
}

export default SsoSuccessfulSignInView
